module.exports = __webpack_public_path__ + "static/media/Era_2020.51d1027d.md";